import { __rest } from 'tslib';
import React__default from 'react';

const SvgImgRaw = (_a) => {
    var { viewbox, title, width = undefined, height = undefined, children = [], extraClass = '' } = _a, others = __rest(_a, ["viewbox", "title", "width", "height", "children", "extraClass"]);
    return (React__default.createElement("svg", Object.assign({ viewBox: viewbox, width: width, height: height, className: extraClass, "data-qa": "svg-icon" }, others),
        React__default.createElement("g", null,
            React__default.createElement("title", { id: "title" }, title)),
        children));
};
const SvgImg = React__default.memo(SvgImgRaw);

export { SvgImg };
